module.exports = __webpack_public_path__ + "img/teams-icon.257e4cd5.svg";